export const SALON_IMAGES = {
  stylingStuehle: "https://customer-assets-39nsmqrw.emergentagent.net/job_style-check-app-2/artifacts/40h5buhq_DSC_0010-3.webp",
  farbkarten: "https://customer-assets-39nsmqrw.emergentagent.net/job_style-check-app-2/artifacts/ze2ks9mt_DSC_0017-2.webp",
  waschbereich: "https://customer-assets-39nsmqrw.emergentagent.net/job_style-check-app-2/artifacts/4n3uj6wn_DSC_0014-2.webp",
};
